/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WMExplicitPartialConsumeRequest
 */
export interface WMExplicitPartialConsumeRequest {
    /**
     * 
     * @type {string}
     * @memberof WMExplicitPartialConsumeRequest
     */
    containerCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WMExplicitPartialConsumeRequest
     */
    operatorId?: string;
    /**
     * 
     * @type {number}
     * @memberof WMExplicitPartialConsumeRequest
     */
    quantity?: number;
}

/**
 * Check if a given object implements the WMExplicitPartialConsumeRequest interface.
 */
export function instanceOfWMExplicitPartialConsumeRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WMExplicitPartialConsumeRequestFromJSON(json: any): WMExplicitPartialConsumeRequest {
    return WMExplicitPartialConsumeRequestFromJSONTyped(json, false);
}

export function WMExplicitPartialConsumeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WMExplicitPartialConsumeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'containerCode': !exists(json, 'containerCode') ? undefined : json['containerCode'],
        'operatorId': !exists(json, 'operatorId') ? undefined : json['operatorId'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}

export function WMExplicitPartialConsumeRequestToJSON(value?: WMExplicitPartialConsumeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'containerCode': value.containerCode,
        'operatorId': value.operatorId,
        'quantity': value.quantity,
    };
}

